import * as XLSX from 'xlsx';
import { translateMessage } from './errorKeyNote';

// cell ของ xlsx รับได้แค่ primitive: object/array -> JSON string
const cell = (v) => (v !== null && typeof v === 'object' ? JSON.stringify(v) : v ?? '');

function appendSheet(wb, detail, sheetName) {
  if (!Array.isArray(detail) || detail.length === 0) return;

  // รวม key ของ request จากทุกแถว (เดิมใช้แค่แถวแรก -> แถวที่มี field เพิ่มจะหายจากไฟล์)
  const requestKeys = [
    ...detail.reduce((set, item) => {
      Object.keys(item?.request || {}).forEach((k) => set.add(k));
      return set;
    }, new Set()),
  ];

  const rows = [[...requestKeys, 'response.message', 'response.data', 'response.error']];
  detail.forEach((item) => {
    const res = item?.response ?? {};
    rows.push([
      ...requestKeys.map((k) => cell(item?.request?.[k])),
      cell(translateMessage(res.message)),
      cell(res.data),
      cell(res.error),
    ]);
  });
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(rows), sheetName);
}

/**
 * ดาวน์โหลดผลของ history "รอบล่าสุด" ของไฟล์ excel หนึ่งรายการ (Sheet: FailDetail / SuccessDetail)
 * ใช้ร่วมกันทั้ง AddHistory และ PreRegisterHistory
 * @returns {boolean} true ถ้ามีข้อมูลและสั่งดาวน์โหลดแล้ว
 */
export function downloadHistoryExcel(excel, filename = 'data.xlsx') {
  const histories = excel?.importHistories;
  if (!Array.isArray(histories) || histories.length === 0) return false;

  const latest = histories[histories.length - 1];
  const wb = XLSX.utils.book_new();
  appendSheet(wb, latest.failDetail, 'FailDetail');
  appendSheet(wb, latest.successDetail, 'SuccessDetail');
  if (wb.SheetNames.length === 0) return false;

  XLSX.writeFile(wb, filename);
  return true;
}